/** Factory the app uses. OWNER: VIEWMODEL+CAMERA agent (keep the name). */
import type { Viewmodel } from '../types';
import { FirstPersonViewmodel } from './viewmodel';

export function createViewmodel(): Viewmodel {
  return new FirstPersonViewmodel();
}
